import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background-color: black;
  color: white;
  max-width: 390px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  width: 100%;
  background-color: black;
  z-index: 10;
`;

const BackButton = styled.span`
  cursor: pointer;
  color: white;
  font-weight: 500;
  font-size: 16px;
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0;
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const CategoryCard = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #333;

  &:hover {
    background: #2a2a2a;
    border-color: #17A2B8;
  }
`;

const CategoryTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: white;
`;

const CategoryDescription = styled.p`
  font-size: 14px;
  color: #ccc;
  margin: 0;
`;

const ItemCount = styled.span`
  font-size: 12px;
  color: #17A2B8;
  font-weight: 500;
`;

const BrowseCatalog = () => {
    const navigate = useNavigate();

    // Mock catalog categories with item counts
    const categories = [
        {
            id: 1,
            title: "Music Equipment",
            description: "Instruments, recording gear, and audio equipment",
            itemCount: 45
        },
        {
            id: 2,
            title: "Studio Services",
            description: "Recording studios, mixing, and mastering services",
            itemCount: 23
        },
        {
            id: 3,
            title: "Event Spaces",
            description: "Venues, rehearsal spaces, and performance locations",
            itemCount: 18
        },
        {
            id: 4,
            title: "Photography",
            description: "Professional photography and visual services",
            itemCount: 31
        },
        {
            id: 5,
            title: "Digital Services",
            description: "Web design, branding, and marketing services",
            itemCount: 27
        }
    ];

    const handleCategoryClick = (categoryId) => {
        navigate(`/catalog/category/${categoryId}`);
    };

    const handleBackClick = () => {
        navigate('/catalog');
    };

    return (
        <Container>
            <Header>
                <BackButton onClick={handleBackClick}>← Back</BackButton>
                <Title>Browse Catalog</Title>
                <div></div>
            </Header>
            
            <Content>
                {categories.map((category) => (
                    <CategoryCard 
                        key={category.id}
                        onClick={() => handleCategoryClick(category.id)}
                    >
                        <CategoryTitle>{category.title}</CategoryTitle>
                        <CategoryDescription>{category.description}</CategoryDescription>
                        <ItemCount>{category.itemCount} items available</ItemCount>
                    </CategoryCard>
                ))}
            </Content>
        </Container>
    );
};

export default BrowseCatalog;